export function isFreeProduct(item) {
	if (item?.is_free === true) return true;
	if (item?.is_free === false) return false;

	const rawPrice = item?.price ?? item?.product?.price ?? item?.product_details?.price;

	// همان منطق WorkshopHelper / WebinarHelper در بک‌اند: null یا ۰ = رایگان
	if (rawPrice === null || rawPrice === undefined) {
		return true;
	}
	if (rawPrice === "") {
		return false;
	}

	if (typeof rawPrice === "number") {
		return rawPrice <= 0;
	}

	const normalizedPrice = String(rawPrice)
		.trim()
		.replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
		.replace(/[٠-٩]/g, (digit) => "٠١٢٣٤٥٦٧٨٩".indexOf(digit));

	if (normalizedPrice === "رایگان") {
		return true;
	}

	const numericText = normalizedPrice.replace(/[^\d.-]/g, "");
	if (!/\d/.test(numericText)) {
		return false;
	}

	const numericPrice = Number(numericText);
	return !Number.isNaN(numericPrice) && numericPrice <= 0;
}

function LockIcon({ unlocked, className = "" }) {
	if (unlocked) {
		return (
			<svg
				className={className}
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden
			>
				<rect x="5" y="11" width="14" height="10" rx="2" />
				<path d="M8 11V8a4 4 0 0 1 7.5-2" />
			</svg>
		);
	}

	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<rect x="5" y="11" width="14" height="10" rx="2" />
			<path d="M8 11V8a4 4 0 0 1 8 0v3" />
		</svg>
	);
}

export const catalogBadgeShellClass =
	"inline-flex min-h-[28px] min-w-[96px] items-center justify-center gap-[6px] rounded-[10px] border border-lightBlue bg-lightCta px-[10px] py-[5px] font-Vazir-700 text-[12px] leading-none text-darkBlue shadow-[0_8px_18px_rgba(39,106,166,0.14)]";

/** کارگاه / وبینار: فقط «رایگان»، بدون قفل (فروش یک‌جا، نه اشتراک کلیپ). */
export function CatalogFreeTag({ className = "" }) {
	return (
		<span dir="rtl" className={`${catalogBadgeShellClass} ${className}`}>
			<span className="truncate">رایگان</span>
		</span>
	);
}

/** کلیپ: رایگان / اشتراکی / اعتبار — با قفل باز یا بسته بر اساس can_watch */
export function ContentAccessBadge({
	label,
	unlocked = false,
	className = "",
}) {
	const iconClass = unlocked
		? "h-[14px] w-[14px] shrink-0 text-darkBlue/75"
		: "h-[14px] w-[14px] shrink-0 text-cta";

	return (
		<span dir="rtl" className={`${catalogBadgeShellClass} ${className}`}>
			<LockIcon unlocked={unlocked} className={iconClass} />
			<span className="truncate">{label}</span>
		</span>
	);
}

/** @deprecated use CatalogFreeTag (workshop/webinar) or ContentAccessBadge (clips) */
export default function FreeBadge(props) {
	return <CatalogFreeTag {...props} />;
}
